module.exports = __webpack_public_path__ + "band_14.9607b426.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_14.png
// module id = qmh0
// module chunks = 0